export default __webpack_public_path__ + "static/media/audio_34_sirena_ambulancia.a858c662.mp3";